import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LocationSelector } from '../../location/locationSelector/locationSelector';
import { NavbarLogo } from './navbarLogo';
import { NavbarLinkList } from './navbarLinkList';
import { largeMediaQuery, navHamburgerMenuQuery } from '../../../common/utilities/sizeHelpers';
import { TopNavigation } from './topNavigation';
import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';

export const Navbar = () => {
    return <>
        <TopNavigation />
        <Header>
            <ContentWrapper>
                <NavContainer>
                    <NavbarLogo />
                    <NavLinkListContainer>
                        <NavbarLinkList/>
                    </NavLinkListContainer>
                </NavContainer>
                <LocationSelector />
            </ContentWrapper>
        </Header>
    </>;
};

Navbar.propTypes = {
    pageId: PropTypes.string
};

const Header = styled.header`
    width: 100%;
    height: 54px;
    background-color: #FFFFFF;
    display: flex;
    font-family: 'Source Sans Pro',sans-serif;
    padding-left: 25px;
    justify-content: space-between;
    align-items: center;

    @media ${smallMediaQuery} {
        padding-left: 5px;
    }

    @media ${largeMediaQuery} {
        justify-content: center;
        padding-left: 0px;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media ${largeMediaQuery} {
        max-width: calc(1218px + 8%);
        padding-left: 4%;
        padding-right: 4%;
    }
`;

const NavContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

const NavLinkListContainer = styled.div`
    ${navHamburgerMenuQuery} {
        display: none;
    };
`;
